// Profil-Voreinstellungen (lokal pro Browser gespeichert).
// Werden bei neuen Arbeitsblättern automatisch vorausgefüllt.

export interface UserSettings {
  teacher: string;
  school: string;
  schoolYear: string;
}

const KEY = 'sketchlessons_settings';
const EMPTY: UserSettings = { teacher: '', school: '', schoolYear: '' };

export function getSettings(): UserSettings {
  try {
    return { ...EMPTY, ...JSON.parse(localStorage.getItem(KEY) || '{}') };
  } catch {
    return { ...EMPTY };
  }
}

export function saveSettings(s: UserSettings): void {
  localStorage.setItem(KEY, JSON.stringify(s));
}
